export default "__VITE_ASSET__DsL$GNu$__"